/**
 * @des 设备判断
 */

export function isTuchongApp() {
    if (typeof window !== 'undefined' && window) {
        const UA = navigator.userAgent;
        return UA.toLocaleLowerCase().indexOf('tuchong') !== -1;
    }
    return (false);
}

// export const isTuchongApp = navigator.userAgent.toLocaleLowerCase().indexOf('tuchong') !== -1;

// 判断当前设备是否是 Android
export function isAndroid() {
    const UA = navigator.userAgent;
    return UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1;
}

export function isIOS() {
    if (typeof window !== 'undefined' && window) {
        const UA = navigator.userAgent;
        return /iPad|iPhone|iPod/.test(UA) && !window.MSStream;
    }
    return (false);
}

// 微信
export function isWeixinBrowser() {
    const UA = navigator.userAgent;
    return /micromessenger/.test(UA.toLowerCase());
}

// 抖音
export function isDouyin() {
    const HREF = window.location.href;
    return HREF.indexOf('douyin') >= 0;
}

export function getPlatform() {
    if (isAndroid()) {
        return 'android';
    }

    if (isIOS()) {
        return 'ios';
    }
    return 'unknown';
}

//识别ios版本
const ua = navigator.userAgent.toLowerCase();
export function ios_ver(){
    return ua.match(/cpu iphone os (.*?) like mac os/);
    // Number(browser.ios_ver()[1].replace('_','.')) 转成常见的数字版本号
}